import { Modal } from "react-bootstrap";
import styled from "styled-components";

const Container = styled.div`
  font-family: Arial, sans-serif;
  padding: 16px 24px;
  ${"" /* max-width: 400px; */}
  ${"" /* background-color: #fff; */}
  border-radius: 10px;
  display:${({isDateTimePicker}) => (isDateTimePicker && "flex")};
  .date-container {
    ${'' /* background-color: #fff; */}
    border-radius: 12px;
    padding: 20px;
    width:41%;
  }

  .time-picker{
    display:flex;
    flex-direction:column;
    width:48%;
    ${'' /* padding:16px; */}
    padding: ${({ isTopPadding }) => (isTopPadding ? isTopPadding : "16px")};
    margin-left:36px;
    height:400px;
    overflow-y:scroll;

    .SelectedDate{
      color:#184A61;
      text-align: center;
      font-family: Lato;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; 
    }
  }
`;

const CalendarHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  ${'' /* background-color: #fff; */}

  .title {
    color: #184a61;
    text-align: center;
    min-width: 140px;

    /* Primary - Lato/Sub Heading */
    font-family: "Lato";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  ${'' /* background-color: #fff; */}

  .day-name {
    color: #bdbdbd;
    text-align: center;
    font-family: "Lato";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
    padding: 4px 8px;
  }

  .day-name-v1 {
    width:47px;
    color: #bdbdbd;
    text-align: center;
    font-family: "Lato";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
    padding: 4px 8px;
  }
`;

const Day = styled.div`
  width:47px;
  padding: 4px 0;
  border-radius: 5px;
  background-color: ${(props) =>
    props.disabled
      ? "#f2f2f2"
      : props.isSelected
        ? "#92A4DA"
        : props.isInRange
          ? "#FEF4F2"
          : "#F8F8F8"};
  color: ${(props) =>
    props.disabled ? "#ccc" : props.isSelected ? "#fff" : "#184A61"};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  text-align: center;
  font-family: "Lato";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;


const Button = styled.span`
  padding: 8px 12px;
  color:  #184A61;

  /* Primary - Lato/Caption */
  font-family: "Lato";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  ${'' /* background:  #FEFEFE; */}
  cursor: pointer;
  margin: 5px;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

const BottomButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom:16px;
  #download-buttons{
    width: 200px;
  }
`;

const ResetButton = styled.div`
  border: none;
  background: none;
  display: flex;
  align-items: center;

  ${"" /* color: #39c0ed; */}
  cursor: pointer;
  ${"" /* text-decoration: underline; */}

  &:hover {
    color: #1d8cb6;
  }

  .reset-text {
    color: #184a61;
    font-family: "Lato";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-left: 12px;
  }
`;

const DownloadButton = styled.button`
display: flex;
height: 40px;
padding: 12px 40px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 4px;
background:${({disabled, color}) => disabled ? "#EFEFEF" : color ? color : '#DA6C74'};
color: ${({disabled}) => disabled ? "#989898" : '#FEFEFE'};
font-family: 'Lato';
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
margin-left:16px;
border:none;
`

const DayWrap = styled.div`
width:100%;
display:flex;
flex-wrap:wrap;
gap:8px;
`;

export const StyledModal = styled(Modal)`
  .modal-dialog {
    ${'' /* width: 360px; */}
    width: ${({ width }) => ( width ? width : "360px")};
    left: ${({ left }) => ( left && left )};
    top: ${({ top }) => ( top ? top : "5%")};
    right: ${({ right }) => ( right && right )};

  }
  .modal-content {
    border-radius: 6px;
    width: ${({ width }) => ( width ? width : "360px")};
    height: ${({ height }) => ( height ? height : "535px")};

  }
  .modal-header {
    ${"" /* background:#005C87; */}
    border-radius:6px 6px 0px 0px;
    padding: 16px 16px 0px 16px;
    border-color: #EFEFEF;
    ${"" /* height:50px; */}
    .close {
      color: white;
      opacity: inherit;
    }
    span {
      color: white;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      font-family: 'Lato';
    }
  }
  .modal-backdrop.in {
    opacity: 0.2;
  }
  .modal-dialog {
    transform: translate(-50%, -50%);
    top:5%;
  }
  .info-popup {
    top: 30%;
    width: ${({ isWidth }) => ( isWidth ? "468px" : "485px")};
    ${'' /* width: 468px; */}
    margin: 0 auto;
    .modal-header {
      border-bottom: 0px;
    }
  }

  .manager-popup{
    top: 1%;

  }
  @media (max-width: 500px) {
    .modal-dialog {
      width: 80%;
      top:5%;
    }
  }
  @media (min-width: 768px) {
    ${'' /* .modal-content {
      margin-left: ${({ height }) => (height ? "-150px" : "0px")};
      margin-top: ${({ height }) => (height ? "-150px" : "0px")};
    } */}
    .modal-dialog {
      top: ${({ top }) => ( top ? top : "5%")};
    }
  }

  
`;

export {Container, CalendarHeader, Grid, Day, Button, BottomButtons, ResetButton, DownloadButton, DayWrap}